module.exports = __webpack_public_path__ + "static/media/placeholder.9758f6c3.jpg";